import data from './nimLang_tr.json';
const LocaleConfig = {
    ...data,
    "AllRight": "Tamam.",
    "Ambulance": " [Ambulans]",
    "Angle": " [Melek]",
    "Angry": " [Kızgın]",
    "Applause": " [Alkış]",
    "Awkward": " [utanç verici]",
    "Beckoning": " [Kalp hareket ediyor]",
    "Bomb": " [Bomba]",
    "Broken": " [Kalp kırıldı]",
    "Bye": " [Hoşça kal]",
    "Cloud": " [Bulutlar]",
    "Cool": " [Harika]",
    "Cry": " [Ağlamak]",
    "Cute": " [Güzel]",
    "Despise": " [Kırkma]",
    "Disdain": " [Kırkma]",
    "Ecstasy": " [Ekstası]",
    "First": " [İlk]",
    "Fist": " [Yumruk]",
    "Fretting": " [Kızgınlık]",
    "Frown": " [Kaşlar kırışıyor]",
    "Funny": " [Kahkahalar]",
    "Ghost": " [Hayalet]",
    "GiveMeFive": " [El alkısı]",
    "GoodJob": " [Güç]",
    "Grimace": " [Yüzü]",
    "Halo": " [İki gözlü yıldız]",
    "Happy": " [Mutlu]",
    "Hi": " [El sallamak]",
    "Hit": " [Seni vurur]",
    "Hold": " [Kaldır]",
    "Joy": " [Mutluluk]",
    "Kiss": " [Özleşme]",
    "Knife": " [Makas]",
    "Laugh": " [Kahkahalar]",
    "Low": " [Düşük]",
    "Mad": " [Öfke]",
    "Mask": " [Maske]",
    "Mischievous": " [Kahkahalar]",
    "Monkey": " [Maymun]",
    "Nice": " [Aşkın]",
    "No": " [Yapma]",
    "NoListen": " [Dinleme]",
    "NoLook": " [Bakmayın]",
    "NoWords": " [Söyleme]",
    "Ok": " [Tamam]",
    "Pig": " [Domuz kafası]",
    "Please": " [Amit Buda]",
    "Poop": " [Sıkıyor]",
    "Rocket": " [Roket]",
    "Sexy": " [Renk]",
    "Shame": " [Utangıcı]",
    "Sleep": " [Uyuyor]",
    "Sleeping": " [Uyuyor]",
    "Snicker": " [Gülüyor]",
    "Spit": " [Dilini uzat]",
    "Squint": " [Gözler]",
    "Surprise": " [Şaşırdı]",
    "Sweat": " [Terlemek]",
    "Tears": " [Gözyaşları]",
    "Terrorist": " [Korku]",
    "Think": " [Düşünmek]",
    "Thrill": " [Korku]",
    "Tired": " [Yıldız]",
    "Uncomfortable": " [acı]",
    "Unhappy": " [Memnun değilim]",
    "acceptFailedText": "Başvuru kabul edilmedi",
    "acceptResultText": "Kabul edildi",
    "acceptText": "Kabul",
    "acceptedText": "Kabul edildi",
    "accountNotMatchText": "Bu hesap yok",
    "accountPlaceholder": "Lütfen hesabınızı girin",
    "accountText": "Hesap Numarası",
    "addButtonText": "Ekle",
    "addChatMemberText": "Sohbet Üyesi Ekle",
    "addFailedText": "Ekleme başarısız oldu",
    "addFriendFailedText": "Arkadaş Eklemek Başarısız Oldu",
    "addFriendMode": "Arkadaş Modu Ekle",
    "addFriendSuccessText": "Başarılı Arkadaş Ekle",
    "addFriendText": "Arkadaş Ekle",
    "addMessageTop": "Bir mesaj verdim.",
    "addStickTopText": "Mesajı yukarı koy",
    "addSuccessText": "Başarılı ekle",
    "addTeamMemberConfirmText": "Eklemek istediğiniz grup üyesini seçin.",
    "addTeamMemberFailedText": "Üye eklenmedi",
    "addTeamMemberSuccessText": "Üye Başarıyla Eklendi",
    "addTeamMemberText": "Üye Ekle",
    "addTeamMemberVerifyText": "Doğrulama bekliyor",
    "addressText": "Adres defteri",
    "aiAntiSpamText": "AI çarpma anti çöp isteği",
    "aiBlockFailedText": "Dijital kişiler için kara liste işlemlerine izin vermeyin",
    "aiConversationSelectFailed": "AI oturumu seçimi başarısız oldu",
    "aiErrorText": "Sunucu meşgul. Lütfen daha sonra tekrar deneyin.",
    "aiFriendNotExists": "Arkadaş yok.",
    "aiFunctionDisabled": "AI mesajlama işlevi açılmadı",
    "aiListTitle": "Benim sayılarım.",
    "aiMemberBanned": "Kullanıcı devre dışı bırakıldı",
    "aiMemberChatBanned": "Kullanıcı yasaklandı",
    "aiMenuText": "Benim sayılarım.",
    "aiMessageHitAntiSpam": "Mesaj çarptı çöp karşıtı",
    "aiNormalTeamChatBanned": "Sıradan üyeler yasak",
    "aiParameterError": "Parametreler hatalı",
    "aiProxyFailedText": "Model isteği olağanüstü",
    "aiRateLimit": "Frekans aşırı",
    "aiSearchInputPlaceholder": "Daha fazla bilgi ekle",
    "aiSearchText": "AI Sözcük Arama",
    "aiSearchingText": "AI sözcük araması. ..",
    "aiSendingText": "Büyük İstek Yanıtı",
    "aiStopFailedText": "Çıkışı durdurma başarısız oldu",
    "aiStreamCancelText": "İstek iptal edildi",
    "aiStreamText": "Dijital İnsan Akımı Çıkışı",
    "aiTeamChatBanned": "Grup üyeleri yasaklandı",
    "aiTeamMemberNotExists": "Grup üyesi yok",
    "aiTranslateEmptyText": "Lütfen çevirmek istediğiniz şeyi girin",
    "aiTranslatePlaceholder": "Çeviri için. ..",
    "aiTranslateText": "AI İşleme",
    "aiTranslatedText": "Kullanım",
    "aiTranslatingText": "AI işlenmektedir. ..",
    "aiUserText": "Dijital İnsan",
    "aleadyInTeamText": "zaten grupta",
    "aliasText": "notlar",
    "allReadText": "Hepsi Okuldu",
    "allUnReadText": "Hepsi okunmadı",
    "amap": "Gaude Haritası",
    "applyFriendFailedText": "Arkadaş ekleme başvurusu başarısız oldu",
    "applyFriendSuccessText": "Arkadaş ekleme başvurusu başarılı oldu",
    "applyFriendText": "Arkadaş olarak ekle",
    "applyTeamSuccessText": "Başvuru başarılı",
    "applyTeamText": "Grup Başvuru",
    "audioMsgText": "Sesli Mesajlar",
    "bdmap": "Baidu Haritası",
    "beAddTeamManagersText": "Yönetici olarak atandı",
    "beMentioned": " [Birisi Benim]",
    "beRejectResultText": "Arkadaş Başvurusu Reddedildi",
    "beRemoveTeamManagersText": "Yönetici kaldırıldı",
    "beRemoveTeamText": "Gruptan çıkarıldı",
    "blackFailedText": "Siyah başarısız oldu",
    "blackListDesc": " (Listeden herhangi bir iletişim almayacaksınız)",
    "blackListTitle": "Kara Liste",
    "blackMenuText": "Kara Liste",
    "blackSuccessText": "Kara başarılı",
    "blackText": "Kara arkadaş",
    "callBusyText": "Birbirleri meşgul",
    "callCancelText": "iptal edildi",
    "callDurationText": "Konuşma süresi",
    "callFailed": "Çağrı başarısız oldu",
    "callMsgText": "Mesajlar",
    "callRejectedText": "Reddedildi",
    "callTimeoutText": "Zaman geçti",
    "cancelText": "iptal et",
    "cancelUploadFailedText": "Yüklemeyi iptal etmek başarısız oldu",
    "chatButtonText": "Sohbet et.",
    "chatHistoryText": "Sohbet kayıtları",
    "closeAgreeModeText": "Grup davetinin kapatılması onay gerektirir",
    "closeApplyModeText": "Grup Denetimi Kapatıldı",
    "closeText": "Kapat",
    "collection": "Koleksiyonlar",
    "collectionFailed": "Koleksiyon başarısız oldu",
    "collectionSuccess": "Toplandı",
    "collectionText": "Koleksiyonlar",
    "commentText": "Mesaj gönderin",
    "confirmDeleteFriendText": "Arkadaşlarınızı silmek için emin misiniz?",
    "confirmDeleteText": "Silmek için emin misin?",
    "confirmRemoveCollection": "Koleksiyonu silmeyi onayladınız mı?",
    "createButtonText": "Oluştur",
    "createDiscussionText": "Tartışma Grubu Oluştur",
    "createTeamFailedText": "Grup oluşturulamadı",
    "createTeamMemberLimitText": "Üst grup sayısı",
    "createTeamSuccessText": "Grup Başarıyla Oluşturuldu",
    "createTeamText": "Bir grup oluştur",
    "customMsgText": "Özel Mesaj",
    "deleteFriendFailedText": "Arkadaşları Silme Başarısız Oldu",
    "deleteFriendSuccessText": "Arkadaşları Silmek Başarılı",
    "deleteFriendText": "Arkadaşları Sil",
    "deleteSessionText": "Oturumu Sil",
    "deleteStickTopText": "Yükseltmeyi iptal et",
    "deleteText": "Sil",
    "discussionAvatarText": "Tartışma grubu avatarı",
    "discussionDoNotDisturbText": "Tartışma Grubu Rahatsız",
    "discussionIdText": "Tartışma Grubu ID",
    "discussionMemberText": "Tartışma Grubu Üyeleri",
    "discussionText": "Tartışma Grubu Bilgileri",
    "discussionTitle": "Tartışma Grubu Adı",
    "dismissTeamConfirmText": "Grupun dağıtılması doğrulanır mı",
    "dismissTeamFailedText": "Grup dağıtılması başarısız oldu",
    "dismissTeamSuccessText": "Grup dağıldı başarılı",
    "dismissTeamText": "Grupları dağıt",
    "editNickInTeamText": "Grupta takma adımı düzenle",
    "emailErrorText": "Posta kutusu yanlış biçimde",
    "emailPlaceholder": "Lütfen e-posta adresini girin.",
    "emailText": "Posta Kutusu",
    "enText": "English",
    "enableV2CloudConversationText": "Bulut oturumunun açılması",
    "enterTeamText": "Grupa girdi.",
    "expiredResultText": "Sonlandı",
    "fileMsgText": "Dosya Mesajı",
    "forwardFailedText": "İletime başarısız oldu",
    "forwardSuccessText": "İletime başarılı",
    "forwardText": "İlerleme",
    "friendListTitle": "Arkadaşım.",
    "friendMenuText": "Arkadaşım.",
    "friendText": "Arkadaşlar",
    "genderPlaceholder": "Lütfen cinsiyeti seçin.",
    "genderText": "Cinsiyet",
    "geoMsgShortText": "Konum",
    "geoMsgText": "Coğrafi Konum Mesajları",
    "getApplyMsgFailedText": "İleti almak başarısız oldu",
    "getCollectionFailed": "Koleksiyon listesi araması başarısız oldu",
    "getHistoryMsgFailedText": "Geçmiş mesajı alınamadı",
    "getRelationFailedText": "İlişki almak başarısız oldu",
    "huff": " [Kızgın]",
    "ill": " [Rahatsız]",
    "imgMsgText": "Resim Mesajı",
    "imgText": "Resimler",
    "inCallText": "Zaten konuşuyoruz. Lütfen konuşmayı bitirerek arayın.",
    "inviteTeamText": "Katılmanıza davet ediyoruz",
    "inviteText": "Davet",
    "joinTeamFailedText": "Grupa katılması başarısız oldu",
    "joinTeamSuccessText": "Grupa başarıyla katıldı",
    "joinTeamText": "Grupa Katıl",
    "joinTeamWithVerifyText": "Grup Başvurusu Gönderildi",
    "languageText": "Dil",
    "leaveDiscussionButtonText": "Tartışma grubundan çık",
    "leaveDiscussionConfirmText": "Tartışma grubundan çıkmayı onaylamak",
    "leaveDiscussionFailedText": "Bu tartışma grubundan çıkmak başarısız oldu",
    "leaveDiscussionSuccessText": "Bu tartışma grubundan başarıyla çıktı",
    "leaveDiscussionText": "Tartışma grubundan ayrıldı",
    "leaveDiscussionTitle": "Tartışma grubundan çık",
    "leaveTeamButtonText": "Sil ve çık",
    "leaveTeamConfirmText": "Gruptan çıkmanın onaylanması",
    "leaveTeamFailedText": "Gruptan çıkmak başarısız oldu",
    "leaveTeamSuccessText": "Gruptan başarıyla çıktı",
    "leaveTeamText": "Gruptan ayrıldı.",
    "leaveTeamTitle": "Gruptan ayrılın",
    "logoutConfirmText": "Giriş yapmaktan emin misiniz?",
    "logoutText": "Giriş çık",
    "man": "Erkek",
    "maxSelectedText": "En çok sadece seçim.",
    "memberNotExistsText": "Kullanıcı yok",
    "msgListTitle": "Mesaj Merkezi",
    "msgMenuText": "Mesaj Merkezi",
    "msgRecallTimeErrorText": "Zaman geçti geri çekilemez",
    "muteAllTeamFailedText": "Tüm yasak açılmadı",
    "muteAllTeamSuccessText": "Tüm yasak başarılı açıldı",
    "muteSessionText": "Rahatsız etmeden aç",
    "needBeInvitedText": "Davet edilen kişinin onayı gerekir.",
    "needMentionText": " @ mesajına ihtiyacınız var mı?",
    "needVerifyText": "Doğrulama gerekiyor",
    "networkDisconnectText": "Ağ bağlantısı kesildi, lütfen ağ ayarlarınızı kontrol edin ve yeniden bağlanmayı deneyin",
    "newGroupOwnerText": "Yeni Efendi Olun",
    "nickInTeamText": "Gruptaki takma adım.",
    "nickPlaceholder": "Lütfen takma adı girin",
    "nickText": "Takma Adı",
    "noMoreCollectionText": "En altına kaydı~",
    "noMoreText": "Daha fazla haber yok.",
    "noPermission": "Hiçbir izininiz yok.",
    "noText": "Red et",
    "notAnAi": "Dijital hesap değil.",
    "notNeedBeInvitedText": "Davet edilen kişinin onayı gerekmez.",
    "notNeedVerifyText": "Doğrulamaya gerek yok",
    "notSupportJoinText": "Tartışma grubu doğrudan katılamadı, lütfen yöneticinizle iletişime geçin.",
    "notSupportMessageText": "Bu mesaj henüz desteklenmedi.",
    "notiMsgText": "Bildirim Mesajı",
    "offlineText": " (Çevrimdışı)",
    "ok": "[OK]",
    "okText": "Emin misiniz?",
    "onDismissDiscussionText": "Tartışma grubu dağıtıldı.",
    "onDismissTeamText": "Grup dağıtıldı.",
    "onRemoveTeamText": "Gruptan çıkarıldınız",
    "onlineText": " (Çevrimiçi)",
    "onlyTeamOwner": "Sadece Efendiler",
    "openAgreeModeText": "Grup davetini açmak için onay gerekir",
    "openApplyModeText": "Grup Denetimi Açıldı",
    "openText": "Aç",
    "oppositeSide": "Birbirine",
    "p2pMsgVisibleModeText": "P2P mesajlarının okunmamış görüntülenmesi",
    "passFriendAskText": "Başvurunuzu kabul ettim, şimdi konuşmaya başlayın.",
    "passResultText": "Arkadaş başvurusu geçti",
    "personUnit": "İnsan",
    "phonePlaceholder": "Lütfen telefon numarasını girin.",
    "phoneText": "Cep telefonu",
    "pinAIText": "PIN Yüksek",
    "processedValidationMessageText": "Doğrulama mesajı işlendi",
    "readText": "Okuldu",
    "recallMessageText": "Bir mesaj geri alındı.",
    "recallReplyMessageText": "Mesaj geri alındı veya silindi",
    "recallText": "Geri çek",
    "receiveText": "Yeni bir mesaj aldınız.",
    "recentConversationText": "Son oturumlar",
    "recentForwardText": "Son Geçenler",
    "recentSessionText": "Son Ziyaretler",
    "reeditText": "Yeniden Düzenle",
    "regenAIMsgFailedText": "Yeniden oluşturma başarısız oldu",
    "rejectFailedText": "Başvuru reddedilmedi",
    "rejectResultText": "Reddedildi",
    "rejectTeamFailedText": "Grup başvurusunu reddetmek başarısız oldu",
    "rejectTeamInviteText": "Grup davetleri reddedildi",
    "rejectText": "Reddedin",
    "rejectedTeamText": "Grup başvuruları reddedildi",
    "rejectedText": "Başvuru reddedildi",
    "removeBlackFailedText": "Karanlığı kaldırmak başarısız oldu",
    "removeBlackSuccessText": "Karayı kaldırmak başarılı",
    "removeBlackText": "Karanlığı kaldır",
    "removeCollectionFailed": "Koleksiyonu silmek başarısız oldu",
    "removeCollectionSuccess": "Koleksiyonu Başarıyla Sildi",
    "removeMessageTop": "Üst mesaj kaldırıldı",
    "removeTeamMemberConfirmText": "Üyelerin kaldırılmasını onayladınız mı?",
    "removeTeamMemberFailedText": "Üye kaldırılmadı",
    "removeTeamMemberSuccessText": "Üyelerin kaldırılması başarılı",
    "removeTeamMemberText": "Üyeleri kaldır",
    "replyText": "Cevap",
    "robotMsgText": "Makine Mesajı",
    "saveFailedText": "Kaydetme başarısız oldu",
    "saveSuccessText": "Başarıyla kaydedildi",
    "saveText": "Kaydet",
    "sdkVersionSelectionText": "SDK Sürümü Seçimi",
    "searchButtonText": "Bul",
    "searchDiscussionMemberPlaceholder": "Tartışma Grubu Üyelerini Ara",
    "searchDiscussionTitle": "Tartışma Grubu",
    "searchEmptyText": "Henüz arkadaş ve grup eklemediniz.",
    "searchFriendTitle": "Arkadaşlar",
    "searchInputPlaceholder": "Arama",
    "searchNoResText": "Arama sonuçları yok",
    "searchTeamMemberPlaceholder": "Grup Üyelerini Ara",
    "searchTeamPlaceholder": "Lütfen grup adını girin",
    "searchTeamTitle": "Gruplar",
    "searchText": "Arama",
    "searchTipText": "Enter Arama",
    "securityTipText": "Sadece Cloud Messenger IM ürünününü deneyimlemek için, para gönderme, kazanma ve diğer para ile ilgili bilgilere güvenmeyin, yabancı telefonlara kolayca aramayın ve kandırılmaya dikkat edin.",
    "selectedText": "Seçilmiş",
    "sendBlackFailedText": "Kara listeye çekildiniz.",
    "sendBtnText": "Gönder",
    "sendEmptyText": "Boş mesaj gönderilemez",
    "sendMsgFailedText": "İleti gönderme başarısız oldu",
    "sendNotFriendFailedText": "Şimdiki arkadaş olmayan ilişkiler",
    "sendText": "Mesaj Gönder",
    "sendToText": "Gönder",
    "sendUsageText": " (Enter basınca, Shift + Enter basınca)",
    "session": "Oturum",
    "setText": "Ayarlar",
    "settingText": "Ayarlar",
    "signPlaceholder": "Lütfen imza girin.",
    "signText": "İmza",
    "strangerNotiText": "Şu anda arkadaşınız değiliz, lütfen kişisel gizliliğinizi korumaya dikkat edin.",
    "strangerText": "Yabancı.",
    "teamAgreeModeExplainText": "Açıldıktan sonra üyeler gruba katılırken grup sahibi veya yönetici izni gerekir",
    "teamAgreeModeText": "Grup Denetimi",
    "teamAll": "Herkes.",
    "teamAtModeText": "kim olabilir herkes",
    "teamAvatarConfirmText": "Kafalar boş olamaz gibi.",
    "teamAvatarText": "Grup başı",
    "teamDoNotDisturbText": "Grup rahatsız etmez",
    "teamIdNotMatchText": "Bu grup numarası bulunmuyor",
    "teamIdPlaceholder": "Lütfen grup kimliğini girin",
    "teamIdText": "Grup ID",
    "teamInfoText": "Grup Bilgileri",
    "teamInviteModeText": "Yeni üyeleri kim davet edebilir?",
    "teamJoinModeExplainText": "Açıldıktan sonra, davet edilen kişinin onayı gerekir.",
    "teamJoinModeFreeText": "Ücretsiz katılın, doğrulama gerekmez",
    "teamJoinModeNeedVerifyText": "Başvuru, grup sahibi veya yönetim onayından sonra katılması gerekir",
    "teamJoinModeText": "Grup davetinin onaylanması gerekiyor",
    "teamListTitle": "Benim grubum.",
    "teamManagerEditText": "Personel Yönetimi",
    "teamManagerEmptyText": "Yönetici yok",
    "teamManagerEnableText": "Grup Yöneticisi etkinleştirilmeli mi",
    "teamManagerLimitText": "Bilgileri kim değiştirebilir?",
    "teamManagerText": "Grup Yöneticisi",
    "teamMemberLimitText": "Grup üyesi sınırına ulaştı",
    "teamMemberNotExist": "Bu grup sohbeti artık mevcut değil.",
    "teamMemberText": "Grup Üyeleri",
    "teamMenuText": "Benim grubum.",
    "teamMsgVisibleModeText": "Okunulmamış grup mesajlarının görüntülenmesi",
    "teamMutePlaceholder": "Mevcut grup sohbeti yasaklanıyor",
    "teamMuteText": "Grup Yasak Sözleri",
    "teamNotExitsText": "Grup mevcut değil",
    "teamOwnerAndManagerText": "Grup sahibi ve yöneticisi",
    "teamOwnerText": "Grup sahibi",
    "teamPowerText": "Grup Yönetimi",
    "teamSignPlaceholder": "Lütfen içeriği girin",
    "teamSignText": "Grup Tanıtımı",
    "teamTitle": "Grup Adı",
    "teamTitleConfirmText": "Grup Adı Boş Olamaz",
    "teamTitlePlaceholder": "Lütfen grup adını girin",
    "teamTopModeText": "Mesajı kim yapabilir?",
    "textMsgText": "Metin Mesajı",
    "tipAIFailedMessageText": "Büyük dil modeli isteği başarısız oldu",
    "tipAIMessageText": "Biçim Desteklenmiyor",
    "tipMsgText": "İpucu Mesajı",
    "topFailedText": "Yukarı yükleme başarısız oldu",
    "topText": "Yukarı",
    "transferOwnerConfirmText": "Transfer sahibinin onaylanması",
    "transferOwnerText": "Transfer sahibi",
    "transferTeamFailedText": "Grup sahibi aktarımı başarısız oldu",
    "transferTeamSuccessText": "Transfer Başarılı",
    "transferToText": "Transfer etmek",
    "txmap": "Tencent Haritası",
    "unTopText": "Yükseltmeyi iptal et",
    "unknow": "bilinmeyen",
    "unknowMsgText": "Bilinmeyen İleti",
    "unmuteAllTeamFailedText": "Tüm yasakların sonlandırılması başarısız oldu",
    "unmuteAllTeamSuccessText": "Tüm yasakların başarıyla sona erdirilmesi",
    "unmuteSessionText": "Rahatsız etmeden iptal et",
    "unreadText": "Okunmadı",
    "updateAliasFailedText": "Not değiştirilmedi",
    "updateAliasSuccessText": "Notu başarıyla değiştirildi",
    "updateAllowAt": "Güncellendi \"@ Tüm İnsan Hakları\" için",
    "updateAllowTop": "Üst mesaj izinleri güncellendi",
    "updateBitConfigMaskFailed": "Grup mesajlarını rahatsız etmeden güncelleme başarısız oldu",
    "updateBitConfigMaskSuccess": "Grup mesajlarını rahatsız etmeden güncelleme başarılı",
    "updateMyMemberNickFailed": "Grup takma adımı güncelleme başarısız oldu",
    "updateMyMemberNickSuccess": "Grup takma adımı başarıyla güncelledim",
    "updateTeamAvatar": "Grup başlığı güncellendi",
    "updateTeamFailedText": "Değiştirme başarısız oldu",
    "updateTeamIntro": "Grup Tanıtımı Güncellendi",
    "updateTeamInviteMode": "Grup hakkı \"Başkalarını davet etme hakkı\" olarak güncellendi",
    "updateTeamManagerFailText": "Grup Yöneticisinin Değiştirilmesi Başarısız Oldu",
    "updateTeamManagerSuccessText": "Grup Yöneticisi Başarıyla Değiştirildi",
    "updateTeamMute": " \"Grup Yasakları\" için güncellendi",
    "updateTeamName": "Grup Adını Güncelleme",
    "updateTeamSuccessText": "Değiştirme başarılı",
    "updateTeamUpdateTeamMode": "Grup hakkı \"Grup Veri Değiştirme İzin\" olarak güncellendi",
    "uploadImgFailedText": "Resim yüklenemedi",
    "uploadLimitText": "Resim video veya dosya boyutu maksimum destek",
    "uploadLimitUnit": "M",
    "userNotInTeam": "Üyeler artık grupta değil.",
    "vedioCallText": "Video Çağrısı",
    "verifyMsgNotExitsText": "Doğrulama mesajı işlendi",
    "videoMsgText": "Video Mesajları",
    "videoText": "Videolar",
    "voiceCallText": "Sesli Arama",
    "voiceToText": "Ses Metine Dönüştürme",
    "voiceToTextFailedText": "Metin dönüştürme başarısız oldu",
    "welcomeText": "Bulut Mesajına Hoşgeldiniz",
    "woman": "Kadın",
    "yesText": "doğru",
    "you": "Sen...",
    "zhText": "Çince"
}


export default LocaleConfig
